import { render, staticRenderFns } from "./free-content-2.vue?vue&type=template&id=236b1864&"
import script from "./free-content-2.vue?vue&type=script&lang=js&"
export * from "./free-content-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports